export const ACCESS_LOADED = "ACCESS_LOADED";
export const ACCESS_UNLOADED = "ACCESS_UNLOADED";
export const USER_LOADED = "ACCESS_LOADED";
export const USER_UNLOADED = "ACCESS_UNLOADED";
export const LEVEL_LOADED = "LEVEL_LOADED";
export const LEVEL_UNLOADED = "LEVEL_UNLOADED";
export const SET_LOADING = "SET_LOADING";
export const CLICK_LOADING = "CLICK_LOADING";
export const SESSION_LOADED="SESSION_LOADED"
export const SESSION_UNLOADED="SESSION_UNLOADED"
export const SESSION_EXPIRED_LOADED="SESSION_EXPIRED_LOADED"
export const SESSION_EXPIRED_UNLOADED="SESSION_EXPIRED_UNLOADED"
export const START_DOWNLOAD="START_DOWNLOAD"